import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate,  } from 'react-router-dom';
import GreyhoundRacing from '../../../CommonComponents/Svg/GreyhoundRacing';
import HorseRacing from '../../../CommonComponents/Svg/HorseRacing';
import CricketSvg from '../../../CommonComponents/Svg/Cricket';
import TennisSvg from '../../../CommonComponents/Svg/Tennis';
import SoccerSvg from '../../../CommonComponents/Svg/Soccer';
import BasketballSvg from '../../../CommonComponents/Svg/Basketball';
import LotterySvg from '../../../CommonComponents/Svg/Lottery';
import "./heartbeat.css";
import { FaSearch } from "react-icons/fa";
import LiveCasinoSvg from '../../../CommonComponents/Svg/LiveCasino';
import TipsAndPreviewsSvg from '../../../CommonComponents/Svg/TipsAndPreviews';
import { isMobile } from 'react-device-detect';
import { launcherUrl } from '../../../AsianExchangeSrc/api';
import { useGradientColor, usePrimaryColor, usePrimaryTextColor } from '../../hooks/useThemeColors';

export const sportsList = [
    { sportsName: "Cricket", eid: "4", icon: CricketSvg, href: "/cricket" },
    { sportsName: "Tennis", eid: "2", icon: TennisSvg, href: "/tennis" },
    { sportsName: "Soccer", eid: "1", icon: SoccerSvg, href: "/soccer" },
    { sportsName: "Horse Racing", eid: "1000", icon: HorseRacing, href: "/horseRacing" },
    { sportsName: "Greyhound Racing", eid: "1001", icon: GreyhoundRacing, href: "/greyhoundRacing" },
    { sportsName: "Basketball", eid: "1002", icon: BasketballSvg, href: "/basketball" },
    { sportsName: "Lottery", eid: "1003", icon: LotterySvg, href: "/lottery?live-casino=true&q1=All&q2=lottery" },
    { sportsName: "Live Casino", eid: "1003", icon: LiveCasinoSvg, href: "/live-casino?live-casino=true&q1=All&q2=casino" },
    { sportsName: "Tips & Previews", eid: "1003", icon: TipsAndPreviewsSvg, href: "/tips-and-previews" }
];

function SiteNavigation({ headerColor = { start: "#315195", end: "#14213D" }, location }) {
    const topBarColor = useSelector(state => state?.site?.siteDetails?.topBarColor);
    const scrollContainerRef = useRef(null);
    const navItemRefs = useRef([]);
    const userData = useSelector((state) => state?.user?.userData);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const PrimaryColor = usePrimaryColor()
  const PrimaryTextColor = usePrimaryTextColor()
  const gradiantcolor = useGradientColor()
  const navigate = useNavigate()
    const scrollToCenter = (index) => {
        const container = scrollContainerRef.current;
        const item = navItemRefs.current[index];
        if (container && item) {
            const scrollLeft = item.offsetLeft - container.offsetWidth / 2 + item.offsetWidth / 2;
            container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
    };

    // const handleAviatorClick = () => {

    // }
        const handleAviatorClick = async (gameId) => {
        localStorage.setItem("returnURL", window.location.href);
        const data = {
            gameId: "SPB-aviator",
            playerId: userData?._id || "",
            displayName: userData?.casinoDisplayName || `Demo${Math.random()*10000}`,
            currency: "INR",
            country: "IN",
            gender: "M",
            birthDate: "1996-10-12",
            mode: "demo",
            device: isMobile ? "mobile" : "desktop",
            returnUrl: window.location.href,
            walletSessionId: userData?.sessionToken || "",
          };
          
    
          try {
            const res = await launcherUrl(data);
            if (res.success) {
              navigate(`/game-lobby?gameId=${encodeURIComponent(res?.data?.url)}`);
            }
          } catch (error) {
            console.error("Launcher error:", error?.response?.data?.message || error?.message || error);
          }
    }
    useEffect(() => {
      const index = sportsList.findIndex((sportRef) => sportRef.href.includes(location.pathname))
      if(index>-1){
        scrollToCenter(index)
      }
      return () => {
        
      }
    }, [location.pathname])
    
    return (
        <div className={`w-full flex flex-row items-end justify-end ${"/full-market, /account".includes(location.pathname) ? "mt-[56px]": ""  }` }
        // style={{ overflowY: "hidden" }}
        >
        <div
          ref={scrollContainerRef}
          className="flex flex-nowrap pr-[100px] scrollbar-visible"
          style={{
            height: "clamp(43px, 4.2vw, 50px)",
            width: "100vw",
            background: PrimaryColor,
            overflowX: "scroll",
            overflowY: "hidden",
          }}
        >
          <button onClick={handleAviatorClick} className="text-black min-h-8 heartBeat bg-black flex justify-center items-center rounded-t-md text-sm px-8 pt-2 mx-1 mt-1 font-bold">
            <img src="/AllWebsiteImages/aviator.png" alt="" height={25} width={45} />
            <span style={{ color: "white", fontSize: "12px", paddingLeft: "5px" }}> Aviator </span>
          </button>
      
          {sportsList.map(({ sportsName, icon: Icon, href }, i) => (
            <NavLink
              key={i}
              to={href}
              ref={el => navItemRefs.current[i] = el}
              onClick={() => scrollToCenter(i)}
              style={{ textWrap: "nowrap" }}
              className={({ isActive }) =>
                `min-h-8 flex justify-center items-center rounded-t-md text-sm px-1 font-bold transition-all duration-150 ${isActive
                  ? 'text-white'
                  : PrimaryTextColor ? `text-[${PrimaryTextColor}]` : "text-black"
                }`
              }
            >
              {({ isActive }) => (
                <div
                  className="flex items-center h-[clamp(43px,4.5vw,50px)] px-3 rounded-t-md mt-2"
                  style={{
                    background: isActive
                      ? gradiantcolor
                      : 'transparent',
                  }}
                >
                  <Icon
                    width="32px"
                    height="29px"
                    color={isActive ? 'white' : PrimaryTextColor ? PrimaryTextColor : "black"}
                  />
                  <span className="text-[14px]">{sportsName}</span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      
        {/* Search Button: Absolutely positioned, not part of scroll */}
        <button
          style={{
            background: "linear-gradient(#525252 0%, #2d2d2d 80%)",
            height: "clamp(43px, 4.2vw, 50px)",
            width: "clamp(43px, 4.2vw, 50px)",
            // position: "absolute",
            top: 0,
            right: 0,
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <FaSearch color='white' size={22} />
        </button>
      </div>
      
    );
}



export default SiteNavigation;
